import styled from 'styled-components';
import { CalciteInput } from 'components/Calcite';

export const StyledTextField = styled(CalciteInput)`
  width: 200px;
`;

export const DatetimeFieldSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SampleValueContainer = styled.div`
  display: table;
  padding: 0.35rem;
  margin-top: 1.75rem;
  border: 1px solid ${({ theme }) => theme.color.border1};
  background-color: ${({ theme }) => theme.color.foreground1};
  font-family: ${({ theme }) => theme.font.codeFamily};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`;
